import React from 'react';
import { StyleSheet } from 'react-native';
import { Button, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import ShareIcon from '../CustomSVGIcons/ShareIcon';

export interface IShareButton {
    url?: string;
    onShareButtonClicked?: () => void;
    title?: string;
    typographyStyle?: React.CSSProperties;
    iconStyle?: React.CSSProperties;
}
const EsShareButton: React.FC<IShareButton> = ({ onShareButtonClicked, iconStyle, typographyStyle }) => {
    const { themeStyle, device } = useThemeContext();
    const styles = dynamicStyles(themeStyle);
    return (
        <Button
            style={styles.detailsButton}
            onClick={onShareButtonClicked}
            aria-label="share button"
            sx={{
                textDecoration: 'none',
                px: 3,
                color: theme[themeStyle].pure_black,
                textTransform: 'none',
                width: device.isMobile ? '70px' : '110px',
                cursor: 'pointer',
                border: `1px solid ${theme[themeStyle].darkGray}`,
                '&:hover': {
                    border: `1px solid ${theme[themeStyle].tag_white}`,
                },
            }}>
            {!device.isMobile && (
                <Typography
                    style={{
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: 14,
                        color: theme[themeStyle].true_white,
                        ...typographyStyle,
                    }}>
                    Share
                </Typography>
            )}
            <ShareIcon style={{ ...iconStyle }} />
        </Button>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        detailsButton: {
            height: '40px',
            padding: '10px',
            borderRadius: 100,
            fontSize: 14,
            fontWeight: '600',
            fontFamily: FONT_ENUM.MAIN_BOLD,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 8,
        },
    });

export { EsShareButton };
